import { API_BASE_URL } from '../config/apiConfig';

/**
 * 根据单元ID获取词汇列表
 * @param {number} unitId - 单元ID
 * @param {Object} filters - 可选筛选条件
 * @param {boolean} filters.is_active - 是否激活
 * @param {number} filters.level - 难度级别
 * @param {boolean} filters.is_phrase - 是否为短语
 * @returns {Promise<Object>} 词汇数据
 */
export const getWordsByUnit = async (unitId, filters = {}) => {
  try {
    // 构建查询参数
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null) {
        params.append(key, filters[key]);
      }
    });
    
    const url = `${API_BASE_URL}/api/textbookwords/unit/${unitId}${params.toString() ? '?' + params.toString() : ''}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('获取单元词汇失败:', error);
    throw error;
  }
};

/**
 * 从localStorage获取单元ID
 * @returns {number|null} 单元ID
 */
export const getUnitIdFromStorage = () => {
  try {
    const selectedTextbookData = localStorage.getItem('selectedTextbook');
    if (!selectedTextbookData) {
      return null;
    }
    
    const parsedData = JSON.parse(selectedTextbookData);
    const unitId = parsedData?.unit?.id;
    
    if (unitId) {
      return parseInt(unitId, 10);
    } else {
      return null;
    }
  } catch (error) {
    console.error('从localStorage获取单元ID失败:', error);
    return null;
  }
};

/**
 * 保存单元ID到localStorage
 * @param {number} unitId - 单元ID
 */
export const saveUnitIdToStorage = (unitId) => {
  try {
    localStorage.setItem('selectedUnitId', unitId.toString());
  } catch (error) {
    console.error('保存单元ID到localStorage失败:', error);
  }
};
